import { getPathSegments } from '../../js/pathGeometry';
import type { PathDataProps } from '../../Path.types';

export const generateLine = (props: PathDataProps): string => getPathSegments(props)
  .map(points => points.map(([x, y], index) => `${index ? 'L' : 'M'}${x},${y}`).join(' '))
  .join(' ');
